import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CoursesService } from '@services/courses.service';
import { NewcourseComponent } from './newcourse/newcourse.component';
import Swal from 'sweetalert2';
@Component({
  selector: 'app-courses',
  templateUrl: './courses.component.html',
  styleUrls: ['./courses.component.css']
})
export class CoursesComponent implements OnInit {

  languages:any[]=[];
  
  constructor(private modal:NgbModal,private languageService:CoursesService,private router:Router) {
    
      
  }

  ngOnInit(): void {
  this.getLangs();
  }


  getLangs(){
      this.languageService.all().subscribe(res=>{
          this.languages=res;
         
      })
  }


  
  openSaveModal(){
    const modalref=  this.modal.open(NewcourseComponent, { size: 'lg' });
    
    modalref.result.then((result)=>{
     this.getLangs();
    });

    }


  
  detail(data:any){
    this.router.navigate(["/coursedetail/"+data])
  }
  delete(data:any){

    Swal.fire({
      title: 'Dikkat',
      text: "Bu kurs silinecek! Onaylıyor musunuz?",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Evet',
      cancelButtonText: 'İptal',
    }).then((result) => {

     
      if (result.isConfirmed) {

          this.languageService.delete(data).subscribe(res=>{
              this.getLangs();
              Swal.fire(
                  'Başarılı!',
                  'Kurs silindi',
                  'success'
                )
          });
       
      }
    })

  }

}
